/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Models_No_AdditionalInputs */



/**
* | output |
* | --- |
* | "No additional models are assigned to this team." |
*
* @param {Team_Models_No_AdditionalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const team_models_no_additional = /** @type {((inputs?: Team_Models_No_AdditionalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Models_No_AdditionalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesem Team sind keine zusätzlichen Modelle zugewiesen.")
	return /** @type {LocalizedString} */ ("No additional models are assigned to this team.")
});